import React, { useState } from "react";
import api from "../..//services/api";
import history from "../history";
import {
  Button,
  Form,
  FormGroup,
  FormControl,
  FormLabel,
} from "react-bootstrap";
import Cookies from "universal-cookie";

export default function CadSenha() {
  const cookies = new Cookies();

  const [CPF, setCPF] = useState("");
  const [Email, setEmail] = useState("");
  const [PriSenha, setPriSenha] = useState("");
  const [SegSenha, setSegSenha] = useState("");

  
  let vCPF = '';
  let vSenha = '';

  function validateForm() {
    if (PriSenha.toUpperCase() === "") {
      return false;
    }
    if (SegSenha.toUpperCase() === "") {
      return false;
    }
    if (PriSenha.toUpperCase() === SegSenha.toUpperCase()) {
      return true;
    } else {
    }
  }

  function validaSenhaNova() {
    console.log(vSenha[0]);

    if (vSenha[0] === PriSenha) {
      alert("Cadastro realizado com sucesso, Avise ao D.P da empresa pelo contato 66 9 8128-8469 e peça que ative sua senha. ");
      history.push("/HOn");
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const resp = await api.get(
      `/datasnap/rest/tsm/CadSenha("${CPF}","${PriSenha}","${Email}")`
    );

    cookies.set('ckCPF', resp.data.result[0].map(usua => usua.CPF), { path: '/' })
    cookies.set('ckSenha', resp.data.result[0].map(usua => usua.SENHA), { path: '/' })
    
    vCPF = cookies.get('ckCPF')
    vSenha = cookies.get('ckSenha')
    
    console.log(vCPF[0])
    console.log(vSenha[0])
    
    if (vCPF[0] === '') {
      alert('Usuario não cadastrado !!!')
    } else {
      if (vSenha[0] === "") {
        alert("Algo de errado !!!");
      } else {
        validaSenhaNova();
      }
    }
       
  }

  function mostrarSenha() {
    var x = document.getElementById("PriSenha");
   
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  }

  function mostrarSenha1() {
    var y = document.getElementById("SegSenha");
   
    if (y.type === "password") {
      y.type = "text";
    } else {
      y.type = "password";
    }
  }

  return (
    <div className="ListPed">
      <div className="container">
        <Form onSubmit={handleSubmit}>
          <h2>HOn-Cadastrar Senha</h2>

          <FormGroup controlId="cpf">
            <br />

            <FormLabel>CPF</FormLabel>
            <FormControl
              autoFocus
              placeholder="somente os números"
              type="text"
              value={CPF}
              onChange={(e) => setCPF(e.target.value)}
            />
          </FormGroup>
          <FormGroup controlId="email">
            <br />
            <FormLabel>Email</FormLabel>
            <FormControl
              autoFocus
              placeholder="email válido"
              type="email"
              value={Email}
              onChange={(e) => setEmail(e.target.value)}
            />
            </FormGroup>
            <FormGroup controlId="password">
            <br />
            <FormLabel>Senha</FormLabel>
            <FormControl
              autoFocus
              placeholder="digite uma senha"
              type="password"
              value={PriSenha}
              id="PriSenha"
              onChange={(e) => setPriSenha(e.target.value)}
            />
            <input
                type="checkbox"
                name="login"
                id="login"
                onClick={(e) => mostrarSenha()}
              />{" "}Mostar Senha

            <br />
            <br />
            <FormLabel>Repetir Senha</FormLabel>
            <FormControl
              autoFocus
              placeholder="repetir a senha"
              type="password"
              value={SegSenha}
              id="SegSenha"
              onChange={(e) => setSegSenha(e.target.value)}
            />
            <input
                type="checkbox"
                name="login"
                id="login"
                onClick={(e) => mostrarSenha1()}
              />{" "}Mostar Senha
          </FormGroup>
          <br />
          <Button block disabled={!validateForm()} type="submit">
            Gravar Senha
          </Button>
        </Form>
      </div>
    </div>
  );
}
